import { Link } from "react-router-dom";
import SearchBox from "@/components/base/SearchBox";
import { siteInfo } from "@/mocks/site";
import { hotKeywords } from "@/mocks/keywords";
import { formatHeat } from "@/utils/content";

export default function HeroSection() {
  const rankList = [...hotKeywords].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const quickWords = ["深夜聚餐", "番位之争", "直播口误", "解约风波", "录音花絮", "署名争议"];

  return (
    <section className="relative overflow-hidden border-b border-background-200/70">
      <div className="absolute inset-0 paper-grain" />
      <div className="relative mx-auto grid max-w-[1280px] gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.35fr_1fr] lg:gap-14 lg:py-20">
        <div className="flex flex-col justify-center">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs text-primary-700">
            <i className="ri-database-2-line" />
            收录 {siteInfo.stats[0].value} 条词条 · 每日更新
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-[2.75rem] md:leading-[1.2]">
            {siteInfo.name}
            <span className="mt-2 block text-xl font-medium text-foreground-700 md:text-3xl">
              输入一个名字，找到对应的瓜料索引
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            按<span className="text-foreground-900">黑料关键词搜索</span>、用
            <span className="text-foreground-900">标签分类</span>筛选，或直接浏览
            <span className="text-foreground-900">热门黑料词索引</span>。
            把散落的话题线索按时间顺好，查瓜不用再翻十几页。
          </p>

          <div className="mt-7 w-full">
            <SearchBox variant="large" />
          </div>

          <div className="mt-5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="whitespace-nowrap">热搜：</span>
            {quickWords.map((word) => (
              <Link
                key={word}
                to={`/keywords?q=${encodeURIComponent(word)}`}
                className="whitespace-nowrap rounded-full border border-background-300 px-3 py-1 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                {word}
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-background-200/70 bg-background-50/80 p-4 md:p-5">
          <div className="flex items-center justify-between">
            <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <i className="ri-fire-line text-accent-500" />
              今日热搜榜
            </h2>
            <Link to="/keywords" className="text-xs text-primary-600 transition-colors hover:text-primary-700">
              完整索引
            </Link>
          </div>
          <ol className="mt-3">
            {rankList.map((keyword, index) => (
              <li key={keyword.word} className="border-b border-background-200/70 last:border-b-0">
                <Link
                  to={`/entry/${keyword.entryId}`}
                  className="group flex items-center gap-3 py-3 transition-colors"
                >
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-semibold ${
                      index < 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                      {keyword.word}
                    </span>
                    <span className="mt-1 block h-1 w-full overflow-hidden rounded-full bg-background-100">
                      <span
                        className="block h-full rounded-full bg-accent-400"
                        style={{ width: `${Math.round((keyword.heat / rankList[0].heat) * 100)}%` }}
                      />
                    </span>
                  </span>
                  <span className="shrink-0 text-xs tabular-nums text-foreground-500">
                    {formatHeat(keyword.heat)}
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>

      <div className="relative border-t border-background-200/70 bg-background-100/70">
        <div className="mx-auto flex max-w-[1280px] flex-wrap items-center justify-start gap-x-10 gap-y-4 px-4 py-5 md:px-6">
          {siteInfo.stats.map((stat) => (
            <div key={stat.label} className="flex items-baseline gap-2">
              <span className="font-heading text-2xl font-bold text-primary-600">{stat.value}</span>
              <span className="text-xs text-foreground-500">
                {stat.label}
                {stat.suffix}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}